import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UserIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.05,13a8,8,0,0,0-7.91,6.86,1,1,0,0,0,1,1.14H19a1,1,0,0,0,1-1.14A8,8,0,0,0,12.05,13Z"
  })]
}), 'UserIcon');